import React from 'react';
import GameList from '../../components/GameList/GameList';

const HomePage: React.FC = () => {
  return <GameList />;
};

export default HomePage;
